import { Component } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { HttpStatusCode } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-terms-condition-modal',
    templateUrl: './terms-condition-modal.component.html',
    standalone: false
})
export class TermsConditionModalComponent {
  termsAndConditionModal = false;
  privacyPolicyModal:boolean = false;
  ModalHeading: string;
  getTermsAndPolicyData: any;
  trustedPrivacyPolicy: any;
  getTermsAndConditionData:any;
  trustedTermsAndCondition:any;

  constructor(
    private commonservice: CommonService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.commonservice.show$.subscribe((status) => {
      this.termsAndConditionModal = status;
    });

    this.commonservice.showPolicy$.subscribe((status) => {
      // console.log(status,'status');
      
      this.privacyPolicyModal = status;
    });

    this.commonservice.title$.subscribe((title) => {
      this.ModalHeading = title;
    });
    this.getTermsAndPolicy();
  }

  close() {
    this.commonservice.close();
  }

  getTermsAndPolicy() {
    this.commonservice.getTermsAndPolicy().subscribe((response) => {
      if (response.statusCode === HttpStatusCode.Ok) {
        this.getTermsAndConditionData = response.data;
        this.trustedTermsAndCondition = this.sanitizer.bypassSecurityTrustHtml(
          this.getTermsAndConditionData?.termsAndConditions
        );

        this.getTermsAndPolicyData = response.data;
        this.trustedPrivacyPolicy = this.sanitizer.bypassSecurityTrustHtml(
          this.getTermsAndPolicyData?.privacyPolicy
        );
      }
    });
  }
}
